import React from 'react'
import PropTypes from 'prop-types'
import Spinner from 'app/protected/common/components/Spinner'
// @ts-ignore
import sheet from './style.scss'

export default function LoadingMessage(props) {
  const { text } = props

  return (
    <div className={sheet.loadingMessage}>
      <h3>{text}</h3>
      <Spinner size="medium" />
    </div>
  )
}

LoadingMessage.propTypes = {
  text: PropTypes.string
}
